import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { loadAstroClientEpic } from './loadAstroClientEpic';
import { loadAstroProductEpic } from './loadAstroProductEpic';
import { loadDlpProductEpic } from './loadDlpProductEpic';

export const secondaryMarketReferentials = () =>
  combineEpics(
    withAppCrashIfException('loadAstroClientEpic', loadAstroClientEpic()),
    withAppCrashIfException('loadAstroProductEpic', loadAstroProductEpic()),
    withAppCrashIfException('loadDlpProductEpic', loadDlpProductEpic()),
  );
